import apiClient, { prefetchApiCsrfToken } from "../common";

export type SaveAuditResult = {
  drive_file_id: string;
  xlsx_file_id: string;
  checklist_file_id: string | null;
  folder_id: string;
  po_folder_id: string;
  filename: string;
};

/**
 * POST /api/v1/supply-documents/{id}/audit/
 * Genera el PDF de la OC y lo archiva en Drive: crea `folderName` dentro de la
 * subcarpeta `folderId` seleccionada, dentro crea "1. PO a Fábrica" y sube el PDF.
 */
export async function apiSavePurchaseOrderAudit(
  supplyDocumentId: string,
  folderId: string,
  folderName: string,
): Promise<SaveAuditResult> {
  await prefetchApiCsrfToken();
  const res = await apiClient.post(
    `supply-documents/${supplyDocumentId}/audit/`,
    { folder_id: folderId, folder_name: folderName },
    {
      withCredentials: true,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    },
  );
  const data = res.data as Partial<SaveAuditResult>;
  return {
    drive_file_id: String(data.drive_file_id ?? ""),
    xlsx_file_id: String(data.xlsx_file_id ?? ""),
    checklist_file_id: data.checklist_file_id ? String(data.checklist_file_id) : null,
    folder_id: String(data.folder_id ?? ""),
    po_folder_id: String(data.po_folder_id ?? ""),
    filename: String(data.filename ?? ""),
  };
}
